export type WeightUnit = "g" | "kg" | "lb" | "oz";
export type DimensionUnit = "cm" | "m" | "in" | "ft";

/** Grams in one of each unit. Matches the server's factors exactly. */
const GRAMS_PER: Record<WeightUnit, number> = {
  g: 1,
  kg: 1000,
  lb: 453.592,
  oz: 28.3495,
};

/**
 * Total parcel weight in kilograms, for DISPLAY only.
 *
 * ⚠️ Nothing here may reach a request body. The server owns conversion — the
 * order and quote requests both carry the customer's own units. This exists
 * purely so a summary line can say "2.3 kg" when the customer typed pounds.
 *
 * It replaces an inline `weight * (unit === "lb" ? 0.4536 : 1)` that was wrong
 * twice over: the factor was not the one used anywhere else, and it treated
 * grams and ounces as kilograms — so a 500 g parcel was reported as 500 kg.
 */
export function totalWeightKg(
  packages: Array<{ weight: number; weightUnit: WeightUnit }>
): number {
  const grams = packages.reduce(
    (sum, p) => sum + p.weight * GRAMS_PER[p.weightUnit],
    0
  );
  return grams / 1000;
}
